/**
 * @generated SignedSource<<aa2e1b057e7ee75def51a410db635109>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4NotificationsData$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Notifications">;
  readonly " $fragmentType": "Nav4NotificationsData";
};
export type Nav4NotificationsData$key = {
  readonly " $data"?: Nav4NotificationsData$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "collabContextRoutingAri"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4NotificationsData",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "collabContextRoutingAri",
          "variableName": "collabContextRoutingAri"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Nav4Notifications"
    }
  ],
  "type": "Query"
};

(node as any).hash = "97f15f8dddc143257dc6ead12a729936";

export default node;
